import React from 'react';
import { Form, Icon, Input, Button, notification } from 'antd';
import AuthService from '../../../services/auth.service';
import './login.scss';
import infogestionImage from '../../../infogestion.png';
import dgiLogo from '../../../assets/dgi.png'
import escudo from '../../../assets/escudo.png'
import logo from '../../../assets/logo.png'

class Login extends React.Component {

  state = {
    logining: false
  }

  handleSubmit = e => {
    e.preventDefault();
    const { history } = this.props;
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.setState({logining: true});
          const resp = await AuthService.login(values.username, values.password);
          this.setState({logining: false});
          Object.keys(resp).forEach(key => localStorage.setItem(key, JSON.stringify(resp[key])));
          history.push('/mi-planificacion');
          window.location.reload();
        } catch (error) {
          this.setState({logining: false});
          notification.error({ message: "Ha ocurrido un error, verifique sus credenciales." });
        }
      }
    });
  };

  render() {

    return (

      <div className="container">
        <img alt="printer" className="printer-image" src={infogestionImage}></img>
        <div className="subcontainer">
          <span className="h1"></span>
          <div className="login-card">
            <div className="login">
              <div className="logos">
                <img src={escudo} alt="dgi-logo" width="80" height="80"></img>
                <img src={logo} alt="dgi-logo" width="80" height="80"></img>
              </div>
              <div className="title">
                <h1 style={{ color: '#fff' }}>Iniciar Sesión</h1>
              </div>
              {this.buildForm()}
              <img className="dgi-logo" src={dgiLogo} alt="dgi-logo" width="150" height="150"></img>
            </div>
          </div>
        </div>
      </div>

    );
  }

  buildForm = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Por favor introduzca su nombre de usuario' }],
          })(
            <Input
              className="login-input"
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Usuario"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Por favor introduzca su constraseña' }],
          })(
            <Input
              className="login-input"
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Contraseña"
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" loading={this.state.logining} htmlType="submit" className="login-form-button">
            Acceder
          </Button>
        </Form.Item>
      </Form>
    );
  }

}

const LoginForm = Form.create({ name: 'normal_login' })(Login);
export default LoginForm;
